import React from 'react';

export class Spinner extends React.Component {
    // TODO: make me fancy.
    render = () => {
        return <span>Loading...</span>
    }
}
